import { Injectable, inject } from '@angular/core';
import { ConfigService } from '@cue-admin/config';
import { HttpClient } from '@angular/common/http';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import { Observable } from 'rxjs';
import { CONSTANTS } from '@cue-admin/constants';
import { GridErrors } from '../models/grid-errors.model';
import { GridPayload } from '../models/gridPayload';

export interface GridDataResponse extends GridDataResult {
  errors: GridErrors;
}

@Injectable({
  providedIn: 'root',
})
export class GridDataService {
  private configService = inject(ConfigService);
  private http = inject(HttpClient);

  fetchData(
    urlPostfix: string,
    event: Parameters<typeof toDataSourceRequestString>[0],
    addition: unknown,
    payload?: GridPayload
  ): Observable<GridDataResponse> {
    const config = this.configService.value;
    if (!config) {
      throw new Error('Application config is not loaded.');
    }

    const url = `${config.apiURL}`;
    /*if (urlPostfix == "/resourceProperty/grid" || urlPostfix == "/resourcePropertyItem/grid") {
      url = "https://private-7f9a1-touchoneadminapi.apiary-mock.com";
    }*/
    const queryString = toDataSourceRequestString(event);
    let requestUrl = url + CONSTANTS.api.prefix + urlPostfix + '?' + queryString;
    if (addition) {
      requestUrl += '&addition=' + encodeURIComponent(JSON.stringify(addition));
    }
    return this.http.post<GridDataResponse>(requestUrl, { data: payload });
  }
}
